import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  GRAPH_MODAL_REQUEST,
} from "./actionTypes"

import {
  graphModalRequestSuccess,
  graphModalRequestError,
} from "./actions"

function* graphModalRequest({payload: data}) {
  try {
    const response = yield call(data.call, data.data)
    yield put(graphModalRequestSuccess(response))
  } catch (error) {
    yield put(graphModalRequestError(error))
  }
}

export function* watchGraphModalRequest() {
  yield takeEvery(GRAPH_MODAL_REQUEST, graphModalRequest);
}

function* graphModalSaga() {
  yield all([
    fork(watchGraphModalRequest),
  ]);
}

export default graphModalSaga
